import './welcome.css';
import WebApp from '@twa-dev/sdk';

const Welcome = () => {
  return (
    <div class="fixed inset-0 z-100 select-none pb-28">
      <div class="welcome-container h-full bg-cover bg-center bg-no-repeat" />
      <div class="center absolute-center flex-col gap-6">
        <svg
          class="animate-spin"
          xmlns="http://www.w3.org/2000/svg"
          width="55"
          height="55"
          viewBox="0 0 55 55"
          fill="none"
        >
          <path
            d="M25.4792 52.9198C30.5401 53.3221 35.6058 52.2047 40.0277 49.7105C44.4496 47.2163 48.0264 43.459 50.3 38.9198C52.5736 34.3805 53.4404 29.2659 52.7896 24.231C52.1388 19.196 49.9998 14.47 46.6467 10.658C43.2937 6.84608 38.879 4.12177 33.9683 2.834C29.0575 1.54623 23.8741 1.7536 19.0819 3.42958C14.2897 5.10555 10.1068 8.17382 7.06898 12.2415C4.03114 16.3091 2.27661 21.1909 2.03008 26.2617"
            stroke="url(#paint0_linear_2693_7709)"
            stroke-width="3"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <defs>
            <linearGradient
              id="paint0_linear_2693_7709"
              x1="2"
              y1="16"
              x2="49.5"
              y2="45.5"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#FFFDF4" />
              <stop offset="1" stop-color="#24EE89" />
            </linearGradient>
          </defs>
        </svg>
        {window.innerHeight > 660 && <div class="text-2xl font-semibold">Loading</div>}
      </div>
      <div class="welcome-bottom-wrapper absolute inset-x-0 bottom-0 z-10 h-72 pt-2">
        <div class="welcome-head mb-6">
          <div class="text-1">Welcome To</div>
          <div class="text-2 mb-6 mt-4 h-20 text-center text-[5rem] font-extrabold leading-none">BC.GAME</div>
        </div>
        <div class="welcome-tips mb-3.5">
          <div class="tip-1">Stay tuned</div>
          <div class="tip-2">More info in official channels</div>
        </div>
        <div class="center gap-3.5">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="41"
            height="41"
            viewBox="0 0 41 41"
            fill="none"
            onClick={() => {
              WebApp.openLink('https://x.com/BCGameOfficial');
            }}
          >
            <path
              d="M39.9973 20.5007C39.9973 30.3494 32.6971 38.4915 23.2135 39.8128C22.3268 39.9358 21.4195 40 20.4986 40C19.4356 40 18.3918 39.9153 17.3752 39.7513C8.09116 38.2565 1 30.2059 1 20.5007C1 9.73103 9.73073 1 20.5 1C31.2693 1 40 9.73103 40 20.5007H39.9973Z"
              fill="#242424"
              stroke="#2D2D2D"
            />
            <path
              d="M12.0411 13L18.6397 21.8248L12 29H13.4948L19.3084 22.7183L24.0052 29H29.091L22.1215 19.6788L28.3021 13H26.8073L21.4538 18.7853L17.1279 13H12.0421H12.0411ZM14.2386 14.1011H16.5745L26.8915 27.8989H24.5556L14.2386 14.1011Z"
              fill="white"
            />
          </svg>

          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="39"
            height="39"
            viewBox="0 0 39 39"
            fill="none"
            onClick={() => WebApp.openTelegramLink('https://t.me/bcgamewin')}
          >
            <path
              d="M19.4556 0.5H19.5444C30.0133 0.5 38.5 8.98671 38.5 19.4556V19.5444C38.5 30.0133 30.0133 38.5 19.5444 38.5H19.4556C8.9867 38.5 0.5 30.0133 0.5 19.5444V19.4556C0.5 8.98671 8.9867 0.5 19.4556 0.5Z"
              fill="#242424"
              stroke="#2D2D2D"
            />
            <path
              d="M9.13548 19.016C9.18194 18.9928 9.22842 18.9707 9.27371 18.9498C10.0612 18.585 10.8591 18.2434 11.6558 17.9019C11.6988 17.9019 11.7708 17.8519 11.8114 17.8357C11.873 17.8089 11.9345 17.7834 11.9961 17.7567C12.1146 17.7055 12.233 17.6556 12.3503 17.6045C12.5873 17.5034 12.823 17.4023 13.0599 17.3012L14.478 16.6936C15.4234 16.2893 16.37 15.8839 17.3154 15.4796C18.2608 15.0753 19.2074 14.6698 20.1528 14.2655C21.0982 13.8612 22.0447 13.4558 22.9901 13.0515C23.9355 12.6472 24.8821 12.2417 25.8275 11.8374C26.0378 11.7468 26.2654 11.6121 26.4907 11.5726C26.68 11.5389 26.8647 11.4738 27.0551 11.4378C27.4163 11.3692 27.8147 11.3414 28.1608 11.4912C28.2804 11.5435 28.3908 11.6167 28.4825 11.7085C28.9216 12.143 28.86 12.8563 28.7671 13.4674C28.1202 17.7264 27.4733 21.9867 26.8252 26.2457C26.7369 26.8301 26.6161 27.4714 26.155 27.8408C25.7648 28.1533 25.2096 28.1882 24.7276 28.0557C24.2456 27.9221 23.8206 27.6421 23.4036 27.3668C21.6743 26.2213 19.9437 25.0758 18.2144 23.9303C17.8032 23.6584 17.3456 23.3029 17.3503 22.8092C17.3526 22.5118 17.5303 22.2469 17.7115 22.011C19.2144 20.05 21.3827 18.7023 22.996 16.8319C23.2236 16.5682 23.4025 16.0918 23.09 15.9396C22.9042 15.849 22.6905 15.9722 22.5209 16.0895C20.3885 17.5708 18.2573 19.0532 16.125 20.5344C15.4293 21.0177 14.6999 21.515 13.8613 21.6335C13.1111 21.7404 12.3561 21.5312 11.6303 21.3175C11.0217 21.1386 10.4142 20.955 9.80912 20.7656C9.4874 20.6657 9.15523 20.5577 8.90668 20.3311C8.65814 20.1046 8.5153 19.7235 8.66513 19.4215C8.7592 19.2321 8.94155 19.1124 9.13319 19.0148L9.13548 19.016Z"
              fill="#FEFFFC"
            />
          </svg>
        </div>
      </div>
    </div>
  );
};

export default Welcome;
